// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".share-menu[data-v-61843ea0]{box-sizing:border-box;padding:1rem}.share-menu h3[data-v-61843ea0]{margin:0 0 .5em}.share-menu .flex[data-v-61843ea0]{gap:1rem}.share-menu .flex svg[data-v-61843ea0]{font-size:1.2rem}.share-menu button[data-v-61843ea0]{float:right;margin-right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
